﻿// Import Vue multiselect styles
require('vue-multiselect/dist/vue-multiselect.css');

// Import axios for API consuming in a clean interface.
import axios from 'axios';

// Import tabs structure
import Tabs from './components/tabs/tabs.vue';
import Tab from './components/tabs/tab.vue';

// Import dashboards
import DashboardManagement from './components/dashboards/Management.vue';
import DashboardDossiers from './components/dashboards/Dossiers.vue';
import DashboardArrangements from './components/dashboards/Arrangements.vue';
import DashboardDeductions from './components/dashboards/Deductions.vue';
import DashboardCurrentDossiersPerStatus from './components/dashboards/CurrentDossiersPerStatus.vue';
import DashboardClosedDossiersPerReason from './components/dashboards/ClosedDossiersPerReason.vue';
import DashboardRentalData from './components/dashboards/RentalData.vue';
import DashboardEvictionReport from './components/dashboards/EvictionReport.vue';

const dashboardApp = {
    components: {
        Tabs,
        Tab,
        DashboardManagement,
        DashboardDossiers,
        DashboardArrangements,
        DashboardDeductions,
        DashboardCurrentDossiersPerStatus,
        DashboardClosedDossiersPerReason,
        DashboardRentalData,
        DashboardEvictionReport,
    },
    data() {
        return {
            loading: false,
            hasRentalData: false,
            hasEvictions: false,
        };
    },
    async created() {
        this.loading = true;

        const rentalApi = this.$store.getters.getText('dashboardApiEndpointRentaldata');
        const evictionApi = this.$store.getters.getText('dashboardApiEndpointEvictions');
        const queryModel = {
            Limit: 0,
            Offset: 0,
            Text: '',
        };

        try {
            const storeRentalData = this.$store.getters.getRentalData;
            if (!storeRentalData.length) {
                const rdResponse = await axios.post(
                    rentalApi,
                    queryModel,
                );
                if (!rdResponse || rdResponse.status != 200 || !rdResponse.data) throw 'no response or bad status';
                if (rdResponse.data.queryCount) this.hasRentalData = true;
            }
            else if (storeRentalData.some(dossier => dossier.dossiernummer)) {
                this.hasRentalData = true;
            }
        } catch (error) {
            console.error('Error loading JSON data: ', error);
        }

        try {
            const storeEvictions = this.$store.getters.getEvictions;
            if (!storeEvictions.length) {
                const eResponse = await axios.post(
                    evictionApi,
                    queryModel,
                );
                if (!eResponse || eResponse.status != 200 || !eResponse.data) throw 'no response or bad status';
                if (eResponse.data.queryCount) this.hasEvictions = true;
            }
            else if (storeEvictions.some(dossier => dossier.dossiernummer)) {
                this.hasEvictions = true;
            }
        } catch (error) {
            console.error('Error loading JSON data: ', error);
        }

        this.loading = false;
    }
};

export default dashboardApp;
